import type { Logger } from 'pino';

const isBrowser = typeof window !== 'undefined';

let logger: Logger;

if (isBrowser) {
    // Browser configuration - Lightweight wrapper around console
    const consoleLogger = {
        level: 'info', // dummy property to satisfy Logger interface
        fatal: (obj: unknown, msg?: string, ...args: unknown[]) => msg !== undefined ? console.error(obj, msg, ...args) : console.error(obj),
        error: (obj: unknown, msg?: string, ...args: unknown[]) => msg !== undefined ? console.error(obj, msg, ...args) : console.error(obj),
        warn:  (obj: unknown, msg?: string, ...args: unknown[]) => msg !== undefined ? console.warn(obj, msg, ...args)  : console.warn(obj),
        info:  (obj: unknown, msg?: string, ...args: unknown[]) => msg !== undefined ? console.info(obj, msg, ...args)  : console.info(obj),
        debug: (obj: unknown, msg?: string, ...args: unknown[]) => msg !== undefined ? console.debug(obj, msg, ...args) : console.debug(obj),
        trace: (obj: unknown, msg?: string, ...args: unknown[]) => msg !== undefined ? console.trace(obj, msg, ...args) : console.trace(obj),
        silent: () => { },
        child: () => consoleLogger as unknown as Logger, // simplistic child support
        bindings: () => ({}),
        flush: () => { },
        isLevelEnabled: () => true,
        levelVal: 30,
        version: 'browser',
    };
    logger = consoleLogger as unknown as Logger;
} else {
    // Server configuration
    // Dynamic require to prevent pino dependencies (thread-stream) from breaking client build in Next.js 16 (Turbopack)
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const pino = require('pino');

    // Note: Transport (pino-pretty) is disabled to prevent 'thread-stream' errors in Next.js middleware/edge
    logger = pino({
        level: process.env.NEXT_PUBLIC_LOG_LEVEL || 'info',
    });
}

export { logger };
